import React from "react";

interface ChevronDownIconProps {
  width?: number | string;
  height?: number | string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ width = 18, height = 18 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default ChevronDownIcon;
